import { defineMessages } from 'react-intl';

const messages: {
	startDateLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	columnDurationLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	columnDurationValue: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	numberOfColumnsLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	cardTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	confirmButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	cancelButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	startDateLabel: {
		id: 'conversation-assistant-message-actions.delete-program-board.start-date-label',
		defaultMessage: 'Start date',
		description:
			'Label shown next to the start date field in the delete program board confirmation dialog for Jira Plans',
	},
	columnDurationLabel: {
		id: 'conversation-assistant-message-actions.delete-program-board.column-duration-label',
		defaultMessage: 'Column duration',
		description:
			'Label shown next to the column duration field in the delete program board confirmation dialog for Jira Plans',
	},
	columnDurationValue: {
		id: 'conversation-assistant-message-actions.delete-program-board.column-duration-value',
		defaultMessage: '{count, plural, one {# week} other {# weeks}}',
		description: 'Column duration value with week/weeks plural',
	},
	numberOfColumnsLabel: {
		id: 'conversation-assistant-message-actions.delete-program-board.number-of-columns-label',
		defaultMessage: 'Number of columns',
		description:
			'Label shown next to the number of columns field in the delete program board confirmation dialog for Jira Plans',
	},
	cardTitle: {
		id: 'conversation-assistant-message-actions.delete-program-board.card-title',
		defaultMessage: 'Remove program board',
		description: 'Title for the remove program board action card',
	},
	confirmButton: {
		id: 'conversation-assistant-message-actions.delete-program-board.confirm-button',
		defaultMessage: 'Remove',
		description:
			'Text on the confirm button in the delete program board dialog for Jira Plans. Clicking it confirms removal of the selected program board',
	},
	cancelButton: {
		id: 'conversation-assistant-message-actions.delete-program-board.cancel-button',
		defaultMessage: 'Cancel',
		description:
			'Text on the cancel button in the delete program board dialog for Jira Plans. Dismisses the dialog without removing the board',
	},
});

export default messages;
